import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const StatsSection = () => {
  const { t } = useTranslation();

  const stats = [
    { value: '20+', label: t('stats.interiorDesign') },
    { value: '40+', label: t('stats.construction') },
    { value: '80+', label: t('stats.architecture') },
    { value: '60+', label: t('stats.completedProjects') },
  ];

  return (
    <section data-testid="stats-section" className="py-16 bg-gold">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              data-testid={`stat-${index}`}
              className="text-center"
            >
              <span className="text-4xl md:text-5xl font-bold text-charcoal">{stat.value}</span>
              <span className="block text-sm uppercase tracking-wider text-charcoal/70 mt-2">{stat.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
